/* eslint-disable react/prop-types */
import { Box } from '@mui/material';
import React from 'react';

const GenerateModalButton = ({ handleOpen, content }) => <Box onClick={handleOpen}>{content}</Box>;
export default GenerateModalButton;
